import FONT_VARIANTS_API from "./StaticApi/FontStyleData";

export const LIVE_API = true;
export const HOST_URL = window.location.origin
export const API_URL = `https://${LIVE_API ? 'api.socialwalls' : 'staging-apis.socialwalls'}.com/socialwalls-api/v1`;
export const IFRAME_URL = LIVE_API ? `https://widget.socialwalls.com/` : `https://test.taggbox.com/embed-widget/lite/`;
export const IFRAME_URL_NEW = LIVE_API ? `https://widget.socialwalls.com/` : `https://test.taggbox.com/embed-widget/react/`;
export const SOCKET_CLIENT_URL = `https://${LIVE_API ? 'socket' : 'staging-socket'}.taggbox.com`;
export const UPLOAD_URL = `https://cloud.socialwalls.com/uploaded/`
export const CLOUD_URL = `https://cloud.socialwalls.com/`;
export const MediaBaseUrl = `https://cloud.socialwalls.com/react-app/media/`;
export const CdnAssetsUrl = `https://cdn3.socialwalls.com/socialwalls/assets/`;
export const SW_LOGO = `${CdnAssetsUrl}socialwalls.svg`;
export const SW_LOGO_ICON = `${CdnAssetsUrl}socialwalls-icon.svg`;
export const CloudUrlStudio = `https://cloud.tagbox.com/app/studio`;
export const NoCameraImgPost = `${MediaBaseUrl}images/no-image.svg`
export const DISPLAY_URL = `https://${!LIVE_API ? '' : 'staging-'}display.socialwalls.com`
export const WIDGET_URL = `https://widget${!LIVE_API ? '' : '-test'}.socialwalls.com`
export const PREVIEW_URL = `${DISPLAY_URL}/${!LIVE_API ? 'socialeditor' : 'socialwall_theme'}/?wall_id=`

export const WASABI_PATH = `https://cloud.tagbox.com/`
export const UGC_UPLOAD_URL = LIVE_API ? 'live' : 'test'

export const TINY_URL = `https://api.tinyurl.com/create`;
export const LUNCH_URL = !LIVE_API ? `https://display.taggbox.com/` : `https://staging-display.socialwalls.com/?wall_id=`;

//ip info
export const IP_INFO = `https://ipinfo.io/json?token=f8cbcfd57fe1f1`;
export const HUBSPOT_URL = `https://calendly.com/taggbox/csm?embed_domain=app.socialwalls.com&embed_type=PopupText`;

export const fontVariants = FONT_VARIANTS_API;
export const LINKEDIN_SUCCESS_CALLBACK = `${API_URL}/user/linkedin/auth`

export const LOGIN = `${API_URL}/user/login`
export const LOGOUT = `${API_URL}/user/logout`
export const FORGOT_PASSWORD = `${API_URL}/user/forgotPasswordEmail`
export const RESET_PASSWORD = `${API_URL}/user/resetPassword`
export const SIGN_UP = `${API_URL}/user/signUp`
export const OTHER_INFO = `${API_URL}/user/otherInfo`
export const USER_INFO = `${API_URL}/user/userInfo`;
export const GET_UPDATED_EXTRA_DATA = `${API_URL}/user/getUpdatedExtraData`;
export const SELECT_PRODUCT = `${API_URL}/user/selectProduct`
export const SIGN_UP_VERIFICATION = `${API_URL}/user/signUpverification`
export const CREATE_WALL = `${API_URL}/user/createWall`;

//notification
export const READ_NOTIFICATION_API = `${API_URL}/notification/notifyread/`;
// export const READ_ALL_NOTIFICATIONS = `${API_URL}/notification/notifyreadAll`;
export const GET_ALL_NOTIFICATION_API = `${API_URL}/notification/getNotification`;
export const DELETE_NOTIFICATION_API = `${API_URL}/notification/deleteNotification`;
export const GET_PLAN_API = `${API_URL}/user/productPlanDetail`;
export const GET_EXTRA_FEEDS_API = `${API_URL}/user/extrafeedwall`;
export const DELETE_EXTRA_FEED = `${API_URL}/feed/delete`;
export const DELETE_EXTRA_FEED_WALL = `${API_URL}/user/deleteextrafeedwall`;
export const UPDATE_USER_PLAN = `${API_URL}/user/updateUserPlan`;
export const CANCEL_PLAN_SUBSCRIPTION = `${API_URL}/accounts/transactions/cancelSubscription`;
export const UPGRADE_PLAN_COUNT = `${API_URL}/user/upgradePlanCount`;
//productSwitch
export const UPGRADE_PRODUCT_ACCESS = `${API_URL}/user/getStartedproduct`;

//moderation
const MODERATION = API_URL + "/moderation";
export const GET_WALLS = `${API_URL}/display/dashboard/get-display-walls`;
export const MOD_AUTO_COMPLETE = `${MODERATION}/post/autocomplete`;
export const EXPIRE_POST_UPDATE = `${MODERATION}/post/updateStatus`;
export const MOD_GET_POSTS = `${MODERATION}/posts`;
export const MOD_POST_PIN = `${MODERATION}/post/pin`;
export const MOD_POST_HIGHLIGHT = `${MODERATION}/post/highlight`;
export const MOD_BLOCK_USER = `${MODERATION}/post/block`;
export const MOD_UPDATE_TAGS = `${MODERATION}/post/updatetags`;
export const WALLS_DETAILS = `${MODERATION}/post/details`;
export const MOD_POST_STATUS = `${MODERATION}/post/status`;
export const MOD_POST_DELETE = `${MODERATION}/post/delete`;
export const MOD_POST_DELETE_ALL = `${MODERATION}/post/deleteall`;
export const MOD_EDIT_POST = `${MODERATION}/post/editpost`;
export const MOD_REORDER_PIN = `${MODERATION}/post/pin/reorder`;
export const UPDATE_INSTA_POST = `${API_URL}/insta/update`

//---------------------UGC-------------------
export const GET_UGC_POST_REQUEST_DATA = `${MODERATION}/ugcStatus`;
export const GET_POST_DETAILS = `${MODERATION}/getUGCpost`;
export const CREATE_UGC_REQUEST = `${MODERATION}/sendugc`;
export const CREATE_UGC_TEMPLATE = `${MODERATION}/templates/create`;
export const REMOVE_UGC_TEMPLATE = `${MODERATION}/templates/delete`;

export const DONWLOAD_IMAGE = `${HOST_URL}/widget/Imgdownload/uploadimages`;



///TRANSACTIONS API
export const GET_USER_ACCOUNT_INFO = `${API_URL}/accounts/getAccountsInfo`
export const GET_USER_PROD_SUBSCRIPTION = `${API_URL}/accounts/getProductSubscriptions`
export const GET_USER_WIDGET_ADDON_DATA = `${API_URL}/accounts/getWidgetAddonSubscriptions`
export const GET_USER_UGC_ADDON_DATA = `${API_URL}/accounts/getUGCAddonSubscriptions`
export const GET_USER_SOCIAL_ACCOUNT = `${API_URL}/accounts/getSocialAccounts`
export const GET_ADD_ACCOUNT_LIST = `${API_URL}/accounts/addAccount`
export const SOCIAL_SHARE_CONNECTION_URL = `${API_URL}/accounts/shareConnectionURL`
export const DOWNLOAD_INVOICE_PDF_URL = `${API_URL}/accounts/generateInvoice`;
export const CARD_MAKE_DEFAULT = `${API_URL}/widget/dashboard/transactions/make_default`
export const CARD_MAKE_DELETE = `${API_URL}/widget/dashboard/transactions/card_delete`
export const CARD_ADDED_LIST = `${API_URL}/widget/dashboard/transactions/paymentCardList`
export const TRANSACTIONS_GET_CARDS = `${API_URL}/widget/dashboard/transactions/get_card_data`


//DASHBOARD
export const VERIFICATION_EMAIL_API = `${API_URL}/user/verificationEmail`;
export const DASHBOARD_SKIP_STEP = `${API_URL}/widget/dashboard/walls/skipStep`
export const STEP_IS_EMBED = `${API_URL}/widget/dashboard/walls/stepIsembed`;

//profile
export const PROFILE_UPDATE = `${API_URL}/user/updateProfile`;

//WALLS
export const WIDGET_WALLS_URL = `${API_URL}/widget/dashboard/widget`
export const WIDGET_WALLS_URL_D = `${API_URL}/display/dashboard/add-update`
export const GET_WALLS_D = `${API_URL}/display/dashboard/get-display-walls`

export const USD_TO_INR = `https://api.fastforex.io/fetch-one?from=USD&to=INR&api_key=e47c21e00d-47292971fa-r1j43q`



//DELETE REDIS KEY
export const DELETE_RADIS_KEY = `${API_URL}/walls/key-delete`


//apps more
export const GET_CTA = `${API_URL}/getcta`
export const UPDATE_CTA = `${API_URL}/walls/cta`
export const UPDATE_AUTOMOD_INDEX = `${API_URL}/automoderation/sort`
export const SET_COLLABRATOR_PASS = `${API_URL}/user/confirmCollaborator`;
export const REJECT_COLLABRATOR_REQUEST = `${API_URL}/user/rejectCollaboratorInfo`;
export const CHECK_COLLABRATOR_EXIST = `${API_URL}/user/checkCollaboratorexist`;


// AppsMore
export const GET_TICKER_DETAILS = `${API_URL}/display/ticker/ticker-type`
export const UPDATE_TICKER_DETAILS = `${API_URL}/display/ticker/update-ticker`
export const ANNOUNCEMENTS_API = `${API_URL}/display/announcements`
export const SUPER_REFRESH = `${API_URL}/display/walls/superRefresh`
// export const GET_FONT_VARIANTS = `${API_URL}/display/editor/font-style`
export const UPDATE_BANNER = `${API_URL}/display/editor/banner-update`
export const GET_NETWORK_LIST = `${API_URL}/display/customPost/network-list`
export const GET_FEED_LIST = `${API_URL}/display/customPost/feed-list`
export const CREATE_CUSTOM_POST = `${API_URL}/display/customPost/create-custom-post`
export const CREATE_CUSTOM_POST_URL = `${API_URL}/display/customPost/create-custom-post-url`
export const LIST_CUSTOM_POST = `${API_URL}/display/customPost/list-custom-posts`
export const UPDATE_CUSTOM_POSTS = `${API_URL}/display/customPost/update-custom-posts`
export const STATUS_UPDATE_CUSTOM_POST = `${API_URL}/display/customPost/update-custom-posts`
export const GET_EDIT_CUSTOM_POST = `${API_URL}/display/customPost/edit-custom-post`

export const IMAGE_DOWNLOAD = `${API_URL}/display/Imgdownload/walls`
export const IMAGE_REQUEST_LIST = `${API_URL}/display/Imgdownload/request-list`
export const IMAGE_REQUEST_CREATE = `${API_URL}/display/Imgdownload/request-create`
export const GOOGLE_ANALYTIC = `${API_URL}/display/editor/googleAnalytic`
export const UPDATE_THEME = `${API_URL}/display/walls/themes/apply-theme`
export const PROFANITY = `${API_URL}/editor/display/profanity`
export const PROFANITY_UPDATE = `${API_URL}/editor/display/profanity-update`
export const AUTOMOD_LIST = `${API_URL}/automoderation/list`
export const AUTOMOD_STATUS = `${API_URL}/automoderation/status`
export const AUTOMOD_DELETE = `${API_URL}/automoderation/delete`
export const CREATE_AUTOMOD = `${API_URL}/automoderation/create`
export const APPS_MORE_FILTERS = `${API_URL}/filter/changeFilter`
export const CUSTOM_CSS = `${API_URL}/custom/css`
export const Get_Collaborators = `${API_URL}/display/collaborator/get-collaborator`
export const Add_Collaborator = `${API_URL}/display/collaborator/add-collaborator`
export const Delete_Collaborator = `${API_URL}/display/collaborator/delete-collaborator`
export const Update_Collaborator = `${API_URL}/display/collaborator/update-collaborator`
export const Choose_Language = `${API_URL}/display/chooseLanguage/update-language`
export const Hashtag_Highlighter = `${API_URL}/display/hashtagHighlighter/update-hashtag`
export const VIDEO_COMPRESS = `${API_URL}/display/walls/video-compress`;
export const Theme_Settting = `${API_URL}/display/walls/setting`;
export const INTERACTIVE = `${API_URL}/display/walls/interactive`;
export const KEY_DELETE = `${API_URL}/walls/key-delete`
export const UpdateCardStyle = `${API_URL}/display/walls/card-style`


//publish
export const UPDATE_PUBLISH_TAGS = `${API_URL}/editor/tag-based-widget/update`;
export const SHARE_CODE = `${API_URL}/editor/shareCodeEmail`;
export const GET_POST = `${API_URL}/editor/getUserPost/`


// ---------------------add Feed--------------------
export const GET_NETWORKS = `${API_URL}/feed/getNetworks`
export const GET_NETWORK_INFO = `${API_URL}/feed/getNetworkInfoById`
export const GET_CONNECTED_ACCOUNT = `${API_URL}/feed/getConnectedAccount`
export const CREATE_FEED = `${API_URL}/feed/createFeed`
export const CREATE_POST = `${API_URL}/feed/createPost`;
export const GET_GOOGLE_API = `${API_URL}/feed/googleplacesearch`;
export const FEED_AUTO_COMPLETE = `${API_URL}/feed/feeds/autocomplete`;
export const GET_WORKPLACE_GROUP_LIST = `${API_URL}/feed/getworkplacegroup`
export const HANDLE_AUTOCOMPLETE = `${API_URL}/feed/feeds/autocomplete`
export const DISCONNECT_ACCOUNT = `${API_URL}/accounts/disconnect`
export const ADD_ACCOUNT = `${API_URL}/feed/connectedAccount/addAccount`
export const TWITTER_CALLBACK = `${API_URL}/feed/connectedAccount/getTwitterCallback`
export const FACEBOOK_AUTOCOMPLETE = `${API_URL}/feed/createFeed/autocomplete`;
export const DELETE_SOCIAL_ACCOUNT_URL = `${API_URL}/accounts/deleteAccount`;
export const GET_ACCOUNT_DETAILS = `${API_URL}/feed/connectedAccount/getAccountDetail`;
export const TIKTOK_HASHTAG_ID = `${API_URL}/feed/tiktokHashtagId`
//--------ManageFeed-----
export const GET_MANAGEFEEDS = `${API_URL}/feed/manage`
export const DELETE_FEED = `${API_URL}/feed/delete`
export const FEED_STATUS_UPDATE = `${API_URL}/feed/statusUpdate`
export const UPDATE_SOCIAL_ACCOUNT = `${API_URL}/feed/updatefeedtoken`

//UGC UPLOADER DISPLAY
export const Ugc_Uploade_Display = `${API_URL}/snapUp/uploader`
export const Export_UgcUploader_Display = `${API_URL}/snapUp/fetchuploader`
export const QR_SNAPUP_UPDATE = `${API_URL}/snapUp/qrSettings`;
export const GET_SNAPUP_DATA = `${API_URL}/snapUp/getSnapup`
export const GET_CUSTOM_LANUAGE = 'https://cloud.socialwalls.com/react-app/media/custom_lang.json'

//Display Loadhome


export const ACCOUNT_SUMMARY = `${API_URL}/display/home/account-summary`;
export const SOCIAL_SUMMARY = `${API_URL}/display/home/social-accounts`;
export const REACT_WALL_SUMMARY = `${API_URL}/display/home/recent-walls`;
export const POST_THIS_WEEK_SUMMARY = `${API_URL}/display/home/last-week-analytics`;

//plan expire
export const SWITCH_TO_FOREVER_PLAN = `${API_URL}/payment/startupplan`;


//strip
export const GET_STRIPE_URL = `${API_URL}/payment/getStripeURL`;
export const CHECK_STRIPE_SESSION = `${API_URL}/payment/checksessionCall`;
export const STRIPE_SUCCESS_CALLBACK = `${API_URL}/payment/successCallStripe`;
export const sendPayLink = `${API_URL}/payment/sendEmailPaymentStatus`;
export const stripeRecurrApi = `${API_URL}/payment/getProrationAmount`;

export const DEMO_POST = `${API_URL}/display/walls/demoStatus`;
export const GET_TRUE_SENSE = `${API_URL}/display/analytics/getTruSenseRec`
export const GET_POST_BY_NETWORK_RECORDS = `${API_URL}/display/analytics/getWallPostsbyNwk`
export const GET_EVENT_VOICE_RECORDS = `${API_URL}/display/analytics/getWallTopEventVoices`
export const GET_WALL_POST_BY_TYPE = `${API_URL}/display/analytics/getWallPostsbyType`
export const GET_WALL_SENTIMENT_LIVE_TREND = `${API_URL}/display/analytics/getwallRecordSentimentLiveTrend`


export const GET_SCREEN_ANALYTICS = `${API_URL}/display/analytics/getScreenAnalyticsRecords`
export const GET_SCREEN_OVERVIEW = `${API_URL}/display/analytics/getAnalyticsScreensOverview`
export const GET_SCREEN_OVERVIEW_NEW = `${API_URL}/display/analytics/getNewAnalyticsScreensOverview`


export const GET_ACTIVITY_WEB_REC = `${API_URL}/display/analytics/getActivityWebRec`
export const API_GET_TOP_REACTION_POST = `${API_URL}/display/analytics/getTopReactionPosts`
export const API_GET_TOP_PERFORMING_POST = `${API_URL}/display/analytics/getTopPerformingPosts`
export const API_GET_WEB_POST_OVERVIEW = `${API_URL}/display/analytics/getAnalyticsWebPostOverview`



//ugc-rights 
export const UGC_GET_REQUEST = `${API_URL}/widget/dashboard/rights/fetch`;
export const UGC_RIGHTS_ACTION = `${API_URL}/widget/dashboard/rights/action`;
export const UGC_DOWNLOAD_CERTIFICATE = `${API_URL}/widget/dashboard/rights/download`;

// Accept Offer
export const PLAN_DISCOUNT = `${API_URL}/accounts/transactions/planDiscount`;

//Moderation update Media Plan
export const GET_POST_MEDIA = `${API_URL}/insta/update`;

// fallback api to get userDetails
export const GET_USER_INFO_FALLBACK = `${API_URL}/user/useronboardingInfo`;




// STUDIO API START
export const STUDIO_API_URL = `${API_URL}/studio/scenes`
export const STUDIO_QUOTES_URL = `${API_URL}/studio/motivationquotes/getCatgeories`
export const STUDIO_QUOTES_DATA_URL = `${API_URL}/studio/motivationquotes/getQuote`
export const STUDIO_CREATE_SCENE = `${API_URL}/studio/create-scene`
export const STUDIO_DELETE_SCENE = `${API_URL}/studio/delete-scene`
export const STUDIO_ADD_WALL = `${API_URL}/studio/content/add-wall`
export const STUDIO_EMBED_SHORT_CODE = `${API_URL}/studio/content/add-embed`
export const STUDIO_SCENE_CONTENT_ADD_IMAGE = `${API_URL}/studio/content/add-image`
export const STUDIO_SCENE_CONTENT_UPDATE_IMAGE = `${API_URL}/studio/content/edit-image`
export const STUDIO_UPDATE_EMBED_SHORT_CODE = `${API_URL}/studio/content/edit-embed`
export const STUDIO_ADD_URL = `${API_URL}/studio/content/add-url`
export const STUDIO_UPDATE_URL = `${API_URL}/studio/content/edit-url`
export const STUDIO_RE_ORDER = `${API_URL}/studio/content/reorder`
export const STUDIO_SECENE_RE_ORDER = `${API_URL}/studio/reorder-scene`
export const STUDIO_DELETE = `${API_URL}/studio/content/delete`
export const STUDIO_UPDATE_STATUS = `${API_URL}/studio/update-status` //put
export const STUDIO_UPDATE_SCENE_STATUS = `${API_URL}/studio/scene/update-status` //put
export const GET_STUDIO_LAYOUTS = `${API_URL}/studio/layouts`
export const GET_STUDIO_APPS = `${API_URL}/studio/apps`
export const LAYOUTS_SWITCH = `${API_URL}/studio/switch-layout`
export const DUPLICATE_SCENE = `${API_URL}/studio/duplicate-scene`
export const UPDATE_SCENE_DURATION = `${API_URL}/studio/content/update-duration`
export const WEATHER_LOCATION_SEARCH = `${API_URL}/studio/app/weather/location-search`
export const GET_WEATHER_CONTENT_INFO = `${API_URL}/studio/app/weather/content-info`
export const GET_WEATHER_LOCATION_INFO = `${API_URL}/studio/app/weather/location`
export const EDIT_SCENE = `${API_URL}/studio/edit-scene`
export const STUDIO_ADD_APP = `${API_URL}/studio/content/add-app`;
export const STUDIO_UPDATE_APP = `${API_URL}/studio/content/edit-app`;
export const STUDIO_INTRO_POPUP = `${API_URL}/studio/update-intro-flag`
export const GET_LEADERBOARD = `${API_URL}/display/analytics/leaderboard`
// export const GET_STUDIO_USER_CHECK_SESSION = `${API_URL}/user/check-session`
export const USER_NOTIFICATIONS = `${API_URL}/user/notifications`

export const PaidPlanIds = ["38", "39", "56", "66", "67"]

// Theme Customization
export const UPDATE_WALL_NAME = `${API_URL}/widget/dashboard/Layouts/Main/addUpdate`;
export const ADD_BACKGROUND = `${API_URL}/display/editor/background`;
export const UPDATE_TAG_BASED_FILTER = `${API_URL}/filter/tagsFilter`;
export const AGENT_INFO = `${API_URL}/agent/info`


export const GET_THEME_SETTINGS = `${API_URL}/display/walls/themes/get-theme-setting`;


export const GET_ANALYTICS_STATUS = `${API_URL}/display/analytics/getAnalytcialStatus`
export const GET_WALL_FEED = `${API_URL}/analytics/getwallfeeds`
export const API_GET_WALL_RECORD_MOST_ACTIVE_USERS = `${API_URL}/display/analytics/getwallRecordMostActiveUsers`
export const API_GET_WALL_RECORD_OVERVIEW = `${API_URL}/display/analytics/getwallRecordOverview`
export const API_GET_WALL_RECORD_SENTIMENT_BY_POST_STATISTICS = `${API_URL}/display/analytics/getwallRecordSentimentByPostStatistics`
export const API_GET_WALL_RECORD_SENTIMENT_BY_POST_STATISTICS_MORE = `${API_URL}/display/analytics/getwallRecordSentimentByPostByType`
export const API_GET_WALL_RECORD_WORD_CLOUD = `${API_URL}/display/analytics/getwallRecordWordCloud`
export const GET_THEMES_D = `${API_URL}/display/walls/themes/get-theme`
export const RECENT_POST_DATA = `${API_URL}/display/home/recentPosts`;
export const VISITOR_CLICKS = `${API_URL}/display/home/visitor-clicks`;
export const SWITCH_THEME_UPDATE = `${API_URL}/display/theme/update`;
export const SOCIAL_WALL_STATUS = `${API_URL}/display/theme/updateSocialWallStatus`;
export const ACCOUNT_SUMMARY_NEW = `${API_URL}/display/home/account-summaryNew`;
export const API_EVENT_DATE_UPDATE = `${API_URL}/user/eventdate`
export const GET_USERTAGS = `${API_URL}/display/analytics/getTopAITag`;
export const NETWORK_AUTH = `${API_URL}/feed/auth/callback`;
export const MFA_VERIFY = `${API_URL}/user/mfa_verify`;
export const MFA_ENABLE = `${API_URL}/user/security`;
export const MFA_SEND_EMAIL = `${API_URL}/user/mfa_send_email`;

// photobooth
export const UPLOAD_PHOTOBOOTH_SETTINGS = `${API_URL}/snapUp/photoBoothUploader`

// Moderation carousel
export const UPDATE_POST_CAROSAL = `${API_URL}/display/walls/carousal-setting`

// upload profile images
export const UPLOAD_FEED_PROFILE_IMAGE = `${API_URL}/feed/uploadCustomProfileImage`

// download snapup data
export const REVIEW_HUB_DOWNLOAD_CSV = `${API_URL}/moderation/dataCollection`